import type { IconName } from '@/components/foundations';

export type NavItemConfig = {
  to: string;
  label: string;
  icon: IconName;
  /** Outras rotas em que o item também fica ativo (ex.: Conexões em /financas/sync). */
  activeAlso?: string[];
};

export type NavGroupConfig = {
  /** Rótulo do grupo (ex.: "Finanças"). Grupo sem rótulo = itens principais. */
  label?: string;
  /** Itens compactos (42px), usados no grupo Finanças. */
  compact?: boolean;
  items: NavItemConfig[];
};

/** Navegação do painel: única fonte dos itens da sidebar. */
export const APP_NAV: NavGroupConfig[] = [
  {
    items: [
      { to: '/', label: 'Visão geral', icon: 'home' },
      { to: '/transacoes', label: 'Transações', icon: 'doc' },
      { to: '/checkout', label: 'Checkout', icon: 'cart' },
      { to: '/integracoes', label: 'Integrações', icon: 'puzzle' },
      { to: '/configuracoes', label: 'Configurações', icon: 'gear' },
    ],
  },
  {
    label: 'Finanças',
    compact: true,
    items: [
      { to: '/financas', label: 'Resumo', icon: 'pie' },
      { to: '/financas/extrato', label: 'Extrato', icon: 'doc' },
      { to: '/financas/parcelas', label: 'Parcelas', icon: 'layers' },
      { to: '/financas/faturas', label: 'Faturas', icon: 'card' },
      { to: '/financas/categorias', label: 'Categorias', icon: 'tag' },
      { to: '/financas/conexoes', label: 'Conexões', icon: 'link', activeAlso: ['/financas/sync'] },
    ],
  },
];
